import { Routes } from '@angular/router';
import { authGuard, homeGuard, rolGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: 'login',
    title: 'Acceso',
    loadComponent: () => import('./features/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'restablecer',
    title: 'Recuperar el acceso',
    loadComponent: () => import('./features/login/restablecer.page').then((m) => m.RestablecerPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        canActivate: [homeGuard],
        loadComponent: () => import('./features/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'dashboard',
        title: 'Dashboard',
        canActivate: [rolGuard('gerente', 'director_comercial', 'comercial')],
        loadComponent: () => import('./features/dashboard/dashboard.page').then((m) => m.DashboardPage),
      },
      {
        path: 'clientes',
        title: 'Clientes',
        loadComponent: () => import('./features/clientes/clientes.page').then((m) => m.ClientesPage),
      },
      {
        path: 'cadenas',
        title: 'Cadenas',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () => import('./features/clientes/cadenas.page').then((m) => m.CadenasPage),
      },
      {
        path: 'proveedores',
        title: 'Proveedores',
        canActivate: [rolGuard('gerente', 'almacen', 'director_comercial')],
        loadComponent: () => import('./features/proveedores/proveedores.page').then((m) => m.ProveedoresPage),
      },
      {
        path: 'articulos',
        title: 'Artículos',
        loadComponent: () => import('./features/articulos/articulos.page').then((m) => m.ArticulosPage),
      },
      {
        path: 'almacenes',
        title: 'Stock e inventario',
        canActivate: [rolGuard('gerente', 'almacen', 'director_comercial')],
        loadComponent: () => import('./features/almacenes/almacenes.page').then((m) => m.AlmacenesPage),
      },
      {
        path: 'rutas',
        title: 'Rutas',
        loadComponent: () => import('./features/rutas/rutas.page').then((m) => m.RutasPage),
      },
      {
        path: 'pedidos',
        title: 'Pedidos de venta',
        loadComponent: () => import('./features/pedidos/pedidos.page').then((m) => m.PedidosPage),
      },
      {
        path: 'pedidos/nuevo',
        title: 'Nuevo pedido',
        canActivate: [rolGuard('gerente', 'director_comercial', 'comercial')],
        loadComponent: () => import('./features/pedidos/pedido-form.page').then((m) => m.PedidoFormPage),
      },
      {
        // Borradores y confirmados que aún no han entrado en picking.
        path: 'pedidos/:id/editar',
        title: 'Editar pedido',
        canActivate: [rolGuard('gerente', 'director_comercial', 'comercial')],
        loadComponent: () => import('./features/pedidos/pedido-form.page').then((m) => m.PedidoFormPage),
      },
      {
        path: 'calendario',
        title: 'Calendario de entregas',
        canActivate: [rolGuard('gerente', 'director_comercial', 'almacen')],
        loadComponent: () => import('./features/calendario/calendario.page').then((m) => m.CalendarioPage),
      },
      {
        path: 'hojas-carga',
        title: 'Hojas de carga',
        // El almacén hace el picking de esta mercancía: la ve y la carga, pero
        // no crea hojas (de ahí que 'hojas-carga/nueva' siga restringida).
        canActivate: [rolGuard('gerente', 'director_comercial', 'almacen')],
        loadComponent: () => import('./features/hojas-carga/hojas-carga.page').then((m) => m.HojasCargaPage),
      },
      {
        path: 'hojas-carga/nueva',
        title: 'Nueva hoja de carga',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () =>
          import('./features/hojas-carga/hoja-carga-form.page').then((m) => m.HojaCargaFormPage),
      },
      {
        // Se edita en cualquier estado, entregada incluida (la firma se conserva).
        path: 'hojas-carga/:id/editar',
        title: 'Editar hoja de carga',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () =>
          import('./features/hojas-carga/hoja-carga-form.page').then((m) => m.HojaCargaFormPage),
      },
      {
        path: 'pedidos-compra',
        title: 'Pedidos a proveedor',
        canActivate: [rolGuard('gerente', 'almacen', 'director_comercial')],
        loadComponent: () =>
          import('./features/compras/pedidos-compra.page').then((m) => m.PedidosCompraPage),
      },
      {
        path: 'suministradoras',
        title: 'Suministradoras',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () =>
          import('./features/compras/suministradoras.page').then((m) => m.SuministradorasPage),
      },
      {
        path: 'recepcion',
        title: 'Recepción',
        canActivate: [rolGuard('gerente', 'almacen', 'director_comercial')],
        loadComponent: () => import('./features/almacenes/recepcion.page').then((m) => m.RecepcionPage),
      },
      {
        path: 'familias',
        title: 'Familias',
        canActivate: [rolGuard('gerente', 'almacen', 'director_comercial')],
        loadComponent: () => import('./features/articulos/familias.page').then((m) => m.FamiliasPage),
      },
      {
        path: 'informe-diario',
        title: 'Informe diario',
        canActivate: [rolGuard('gerente', 'director_comercial', 'comercial')],
        loadComponent: () =>
          import('./features/dashboard/informe-diario.page').then((m) => m.InformeDiarioPage),
      },
      {
        path: 'picking',
        title: 'Picking',
        canActivate: [rolGuard('gerente', 'almacen', 'director_comercial')],
        loadComponent: () => import('./features/pedidos/picking.page').then((m) => m.PickingPage),
      },
      {
        path: 'repartos',
        title: 'Repartos',
        canActivate: [rolGuard('gerente', 'repartidor', 'director_comercial')],
        loadComponent: () => import('./features/reparto/repartos.page').then((m) => m.RepartosPage),
      },
      {
        path: 'flota',
        title: 'Flota y transportistas',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () => import('./features/flota/flota.page').then((m) => m.FlotaPage),
      },
      {
        path: 'repartos/:id',
        title: 'Reparto',
        canActivate: [rolGuard('gerente', 'repartidor', 'director_comercial')],
        loadComponent: () => import('./features/reparto/reparto-detalle.page').then((m) => m.RepartoDetallePage),
      },
      {
        path: 'facturas',
        title: 'Facturación',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () => import('./features/facturacion/facturas.page').then((m) => m.FacturasPage),
      },
      {
        path: 'tarifas',
        title: 'Tarifas y promociones',
        canActivate: [rolGuard('gerente', 'director_comercial')],
        loadComponent: () => import('./features/tarifas/tarifas.page').then((m) => m.TarifasPage),
      },
      {
        // Sin rol: la declaración responsable debe poder consultarla cualquier usuario del sistema.
        path: 'verifactu/declaracion-responsable',
        title: 'Declaración responsable VERI*FACTU',
        loadComponent: () => import('./features/verifactu/declaracion-responsable.page').then((m) => m.DeclaracionResponsablePage),
      },
      {
        path: 'ajustes',
        title: 'Configuración',
        canActivate: [rolGuard('gerente')],
        loadComponent: () => import('./features/ajustes/ajustes.page').then((m) => m.AjustesPage),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
